import React from 'react';

const ConceptSidebar = ({ 
  concepts, 
  moduleId, 
  selectedConcept, 
  setSelectedConcept, 
  conceptDetailsRef 
}) => {
  return (
    <div className="concept-sidebar">
      <ul className="concept-list">
        {concepts?.map((concept, index) => (
          <li key={index}>
            <button
              className={`concept-btn ${selectedConcept?.detail_title === concept.detail_title ? 'active' : ''}`}
              onClick={() => setSelectedConcept(concept)}
            >
              {concept.detail_title}
            </button>
          </li>
        ))}
      </ul>
      {selectedConcept && (
        <div className="concept-details" ref={conceptDetailsRef}>
          <h4>{selectedConcept.detail_title}</h4>
          <div dangerouslySetInnerHTML={{ __html: selectedConcept.detail_description }} />
        </div>
      )}
    </div>
  );
};

export default ConceptSidebar;
